webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(8)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(11),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(3);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(2);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

new _vue2.default(_vue2.default.util.extend(_App2.default)).$mount('#app');

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vBar = __webpack_require__(10);

var _vBar2 = _interopRequireDefault(_vBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },
    components: { VBar: _vBar2.default }
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _detectResize = __webpack_require__(7);

exports.default = {
    data: function data() {
        return {
            dragging: {
                enable: false,
                axis: '',
                offset: ''
            },
            bars: {
                horizontal: {
                    elm: '',
                    parent: '',
                    size: 0
                },
                vertical: {
                    elm: '',
                    parent: '',
                    size: 0
                }
            },
            wrapperObj: {
                elm: '',
                scrollHeight: '',
                scrollWidth: '',
                scrollLeft: '',
                scrollTop: ''
            },
            container: {
                elm: '',
                scrollHeight: '',
                scrollWidth: ''
            }
        };
    },
    mounted: function mounted() {
        (0, _detectResize.addResizeListener)(this.$refs.container, this.resize);
        (0, _detectResize.addResizeListener)(this.$refs.wrapperRef.children[0], this.resize);

        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('touchmove', this.onDrag);
        document.addEventListener('mouseup', this.stopDrag);
        document.addEventListener('touchend', this.stopDrag);

        this.getSizes();
    },
    beforeDestroy: function beforeDestroy() {
        (0, _detectResize.removeResizeListener)(this.$refs.container, this.resize);
        (0, _detectResize.removeResizeListener)(this.$refs.wrapperRef.children[0], this.resize);

        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('touchmove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        document.removeEventListener('touchend', this.stopDrag);
    },

    computed: {
        propWrapperSize: function propWrapperSize() {
            return this.wrapper ? this.wrapper : '';
        },
        propBarVertical: function propBarVertical() {
            return this.vBar ? this.vBar : '';
        },
        propBarInternalVertical: function propBarInternalVertical() {
            return this.vBarInternal ? this.vBarInternal : '';
        },
        propBarHorizontal: function propBarHorizontal() {
            return this.hBar ? this.hBar : '';
        },
        propBarInternalHorizontal: function propBarInternalHorizontal() {
            return this.hBarInternal ? this.hBarInternal : '';
        },
        barSizeVertical: function barSizeVertical() {
            if (this.bars.horizontal.size && this.bars.vertical.size) {
                return {
                    height: 'calc(100% - 16px)'
                };
            }
        },
        barSizeHorizontal: function barSizeHorizontal() {
            if (this.bars.horizontal.size && this.bars.vertical.size) {
                return {
                    width: 'calc(100% - 16px)'
                };
            }
        },
        barInternalVertical: function barInternalVertical() {
            var barTop = this.getBarInternal('Y');

            return {
                height: this.bars.vertical.size + 'px',
                top: barTop + 'px'
            };
        },
        barInternalHorizontal: function barInternalHorizontal() {
            var barLeft = this.getBarInternal('X');

            return {
                width: this.bars.horizontal.size + 'px',
                left: barLeft + 'px'
            };
        },
        validationScrolls: function validationScrolls() {
            if (!this.bars.horizontal.size) {
                return 'overflowX: hidden';
            }
            if (!this.bars.vertical.size) {
                return 'overflowY: hidden';
            }
        }
    },
    methods: {
        scroll: function scroll(e) {

            var Y = 0,
                X = 0;


            this.getSizes(X, Y);
        },
        resize: function resize() {
            this.getSizes();
        },
        getBarInternal: function getBarInternal(axis) {
            var internalSize = void 0,
                positionWrapper = void 0,
                sizeWrapper = void 0,
                sizeBar = void 0,
                sizeContainer = void 0,
                regulatorSize = void 0;

            if (this.bars.horizontal.size && this.bars.vertical.size) {
                regulatorSize = 40;
            } else {
                regulatorSize = 32;
            }

            if (axis === 'X') {
                positionWrapper = this.wrapperObj.scrollLeft;
                sizeWrapper = this.wrapperObj.scrollWidth;
                sizeBar = this.bars.horizontal.size + regulatorSize;
                sizeContainer = this.container.scrollWidth;
            } else if (axis === 'Y') {
                positionWrapper = this.wrapperObj.scrollTop;
                sizeWrapper = this.wrapperObj.scrollHeight;
                sizeBar = this.bars.vertical.size + regulatorSize;
                sizeContainer = this.container.scrollHeight;
            }
            internalSize = positionWrapper / (sizeWrapper - sizeContainer) * (sizeContainer - sizeBar);

            return internalSize;
        },
        getCoordinates: function getCoordinates(e, axis) {
            var coordinate = void 0,
                sizeWrapper = void 0,
                sizeBar = void 0,
                sizeContainer = void 0,
                offsetContainer = void 0,
                clientDirection = void 0;

            if (axis === 'X') {
                sizeWrapper = this.wrapperObj.scrollWidth;
                sizeBar = this.bars.horizontal.size;
                sizeContainer = this.container.scrollWidth;
                offsetContainer = this.container.elm.offsetLeft;
                clientDirection = e.clientX - this.dragging.offset;
            } else if (axis === 'Y') {
                sizeWrapper = this.wrapperObj.scrollHeight;
                sizeBar = this.bars.vertical.size;
                sizeContainer = this.container.scrollHeight;
                offsetContainer = this.container.elm.offsetTop - this.bars.vertical.size * 1.4;
                clientDirection = e.clientY - this.dragging.offset;
            }
            coordinate = (sizeWrapper - sizeContainer) * (clientDirection - offsetContainer) / (sizeContainer - sizeBar);

            return coordinate;
        },
        startDrag: function startDrag(e) {
            e.preventDefault();
            e.stopPropagation();

            e = e.changedTouches ? e.changedTouches[0] : e;

            var axis = e.target.getAttribute('data-axis'),
                dataDrag = e.target.getAttribute('data-drag-source');

            var offset = void 0,
                elementOffset = void 0;

            if (axis === 'Y') {
                if (dataDrag === 'bar') {
                    elementOffset = e.explicitOriginalTarget.offsetTop + this.bars.vertical.size * 1.4;
                } else if (dataDrag === 'internal') {
                    elementOffset = e.clientY - this.bars.vertical.elm.offsetTop;
                }
            } else if (axis === 'Y') {
                if (dataDrag === 'bar') {
                    elementOffset = e.explicitOriginalTarget.offsetTop + this.bars.horizontal.size * 1.4;
                } else if (dataDrag === 'internal') {
                    elementOffset = e.clientX - this.bars.horizontal.elm.offsetTop;
                }
            }

            offset = elementOffset;

            this.dragging = {
                enable: true,
                axis: axis,
                offset: offset
            };
        },
        onDrag: function onDrag(e) {
            if (this.dragging.enable) {
                e.preventDefault();
                e.stopPropagation();

                e = e.changedTouches ? e.changedTouches[0] : e;

                var wrapper = this.$refs.wrapperRef;

                if (this.dragging.axis === 'X') {
                    wrapper.scrollLeft = this.getCoordinates(e, 'X');
                } else if (this.dragging.axis === 'Y') {
                    wrapper.scrollTop = this.getCoordinates(e, 'Y');
                }

                this.getSizes();
            }
        },
        stopDrag: function stopDrag(e) {
            if (this.dragging.enable) {
                this.dragging = {
                    enable: false,
                    axis: ''
                };
            }
        },
        getSizes: function getSizes(X, Y) {
            var wrapperRef = this.$refs.wrapperRef,
                containerRef = this.$refs.container,
                verticalBarRef = this.$refs.verticalBar,
                verticalInternalBarRef = this.$refs.verticalInternalBar,
                horizontalBarRef = this.$refs.horizontalBar,
                horizontalInternalBarRef = this.$refs.horizontalInternalBar;

            this.wrapperObj = {
                elm: wrapperRef,
                scrollHeight: wrapperRef.scrollHeight,
                scrollWidth: wrapperRef.scrollWidth,
                scrollLeft: wrapperRef.scrollLeft,
                scrollTop: wrapperRef.scrollTop
            };

            this.container = {
                elm: containerRef,
                scrollHeight: containerRef.scrollHeight,
                scrollWidth: containerRef.scrollWidth
            };

            this.bars.horizontal.elm = horizontalInternalBarRef;
            this.bars.horizontal.parent = horizontalBarRef;

            this.bars.horizontal.size = this.wrapperObj.scrollWidth - this.container.scrollWidth > 24 && this.wrapperObj.scrollWidth - this.container.scrollWidth !== 0 ? this.container.scrollWidth / this.wrapperObj.scrollWidth * this.container.scrollWidth : 0;

            this.bars.vertical.elm = verticalInternalBarRef;
            this.bars.vertical.parent = verticalBarRef;

            this.bars.vertical.size = this.wrapperObj.scrollHeight - this.container.scrollHeight > 24 && this.wrapperObj.scrollHeight - this.container.scrollHeight !== 0 ? this.container.scrollHeight / this.wrapperObj.scrollHeight * this.container.scrollHeight : 0;
        }
    },
    props: ['wrapper', 'vBar', 'vBarInternal', 'hBar', 'hBarInternal']
};

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(12),
  /* scopeId */
  "data-v-7740dc4f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component"
  }, [_c('v-bar', {
    attrs: {
      "wrapper": "wrapper",
      "vBar": "verticalBarClass",
      "vBarInternal": "verticalBarInternalClass",
      "hBar": "horizontalBarClass",
      "hBarInternal": "horizontalBarInternalClass"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "internal"
  }, [_c('h3', {
    staticClass: "is-marginless"
  }, [_vm._v("Welcome to")]), _c('h1', {
    staticClass: "title is-marginless"
  }, [_vm._v("VBar")]), _c('h4', {
    staticClass: "is-marginless"
  }, [_vm._v("The virtual responsive crossbrowser scrollbar "), _c('br'), _vm._v(" component for VueJS 2x")]), _c('div', {
    staticClass: "steps"
  }, [_c('h2', [_vm._v("Usage")]), _c('h3', [_vm._v("Install")]), _c('h4', [_vm._v("Using NPM")]), _c('code', [_c('pre', [_vm._v("npm i v-bar")])]), _c('h4', [_vm._v("Using yarn")]), _c('code', [_c('pre', [_vm._v("yarn add v-bar")])]), _c('h3', [_vm._v("In your "), _c('code', [_vm._v(".vue")]), _vm._v(" component create a class to your wrapper")]), _c('h4', [_vm._v("Using SASS")]), _c('code', [_c('pre', [_vm._v("<style lang=\"sass\">\n    .wrapper\n        height: 300px\n        width: 300px\n</style>")])]), _c('h4', [_vm._v("Using Simple CSS")]), _c('code', [_c('pre', [_vm._v("<style>\n    .wrapper {\n        height: 300px;\n        width: 300px;\n    }\n</style>")])]), _c('h3', [_vm._v("Include the component in your template")]), _c('h4', [_vm._v("Using Pug")]), _c('code', [_c('pre', [_vm._v("<template lang=\"pug\">\n    v-bar(wrapper=\"wrapper\",\n        vBar=\"\",\n        vBarInternal=\"\",\n        hBar=\"\",\n        hBarInternal=\"\")\n        ...\n</template>")])]), _c('h4', [_vm._v("Using Simple HTML")]), _c('code', [_c('pre', [_vm._v("<template>\n   <v-bar wrapper=\"wrapper\"\n       vBar=\"\"\n       vBarInternal=\"\"\n       hBar=\"\"\n       hBarInternal=\"\">\n       ...\n   </v-bar>\n</template>")])]), _c('h4', [_vm._v("Import the component")]), _c('code', [_c('pre', [_vm._v("<script>\n  import VBar from 'v-bar'\n  export default {\n      components: { VBar }\n  }\n</script>")])]), _c('h3', [_vm._v("Options")]), _c('h4', [_vm._v("VBar is fully customizable. You can use your CSS classes to make it even more beautiful :)")]), _c('code', [_c('pre', [_c('b', [_vm._v("required")]), _vm._v(" wrapper=\"\"\n"), _c('b', [_vm._v("optional")]), _vm._v(" vBar=\"\"\n"), _c('b', [_vm._v("optional")]), _vm._v(" vBarInternal=\"\"\n"), _c('b', [_vm._v("optional")]), _vm._v(" hBar=\"\"\n"), _c('b', [_vm._v("optional")]), _vm._v(" hBarInternal=\"\"")])]), _c('h3', [_vm._v("To contribute "), _c('br'), _vm._v(" and make it better")]), _c('h4', [_vm._v("Clone the repo,")]), _c('h4', [_vm._v("change what you want and")]), _c('h4', [_vm._v("send PR")]), _c('h2', [_vm._v("Contributions are always welcome!")]), _c('h3', [_vm._v("Build Setup")]), _c('h4', [_vm._v("Install dependencies")]), _c('h4', [_vm._v("Using NPM")]), _c('code', [_c('pre', [_vm._v("npm i")])]), _c('h4', [_vm._v("Using yarn")]), _c('code', [_c('pre', [_vm._v("yarn")])]), _c('h4', [_vm._v("Serve with hot reload at localhost:8080")]), _c('code', [_c('pre', [_vm._v("npm run dev")])]), _c('h4', [_vm._v("build for production with minification")]), _c('code', [_c('pre', [_vm._v("npm run build")])]), _c('h4', [_vm._v("build for production and view the bundle analyzer report")]), _c('code', [_c('pre', [_vm._v("npm run build --report")])]), _c('h4', [_vm._v("Contributors")]), _c('h3', [_vm._v("Luigui Delyer")]), _c('h5', [_vm._v("https://github.com/luiguild")]), _c('h3', [_vm._v("Carlo Fragni")]), _c('h5', [_vm._v("https://github.com/carlofragni")]), _c('h3', [_vm._v("SoullessWaffle")]), _c('h5', [_vm._v("https://github.com/SoullessWaffle")]), _c('h3', [_vm._v("Robbe Clerckx")]), _c('h5', [_vm._v("https://github.com/robbeman")]), _c('h3', [_vm._v("antshil")]), _c('h5', [_vm._v("https://github.com/antshil")])])])])]), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icons-group"
  }, [_c('a', {
    staticClass: "icons",
    attrs: {
      "href": "https://github.com/luiguild/v-bar",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github-alt"
  })]), _c('a', {
    staticClass: "icons",
    attrs: {
      "href": "https://twitter.com/luiguild",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])])
}]}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.propWrapperSize,
    attrs: {
      "id": "vbar"
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "bar--container",
    on: {
      "wheel": _vm.scroll,
      "touchmove": _vm.scroll
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bars.vertical.size),
      expression: "bars.vertical.size"
    }],
    ref: "verticalBar",
    staticClass: "bar--vertical",
    class: _vm.propBarVertical,
    style: (_vm.barSizeVertical),
    attrs: {
      "data-axis": "Y",
      "data-drag-source": "bar"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  }, [_c('div', {
    ref: "verticalInternalBar",
    staticClass: "bar--vertical-internal",
    class: _vm.propBarInternalVertical,
    style: (_vm.barInternalVertical),
    attrs: {
      "data-axis": "Y",
      "data-drag-source": "internal"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bars.horizontal.size),
      expression: "bars.horizontal.size"
    }],
    staticClass: "bar--horizontal",
    class: _vm.propBarHorizontal,
    style: (_vm.barSizeHorizontal),
    attrs: {
      "data-axis": "X",
      "data-drag-source": "bar"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  }, [_c('div', {
    ref: "horizontalBar",
    staticClass: "bar--horizontal-internal",
    class: _vm.propBarInternalHorizontal,
    style: (_vm.barInternalHorizontal),
    attrs: {
      "data-axis": "X",
      "data-drag-source": "internal"
    },
    on: {
      "touchstart": _vm.startDrag,
      "mousedown": _vm.startDrag
    }
  })]), _c('div', {
    ref: "wrapperRef",
    staticClass: "bar--wrapper",
    style: (_vm.validationScrolls)
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.469ed2d6a8e1cda9b93f.js